export default __webpack_public_path__ + "static/media/cakap-logo.01a8476c.svg";